import { PresentationData } from '../../models/PresentationData';
import { aetherApi } from './aetherApi';

export const presentationApi = aetherApi.injectEndpoints({
  endpoints: (builder) => ({
    getPresentationData: builder.query<PresentationData, void>({
      query: () => 'api/v2/presentation',
    }),
  }),
});

export const { useLazyGetPresentationDataQuery } = presentationApi;
